// Breadcrumb — current page'in atalarını gösteren navigasyon yolu.
// Kullanım:
//   <Breadcrumb activePage="crm-pipeline" onNavigate={navigate} />
// utils/pageRoutes.js getBreadcrumb() ile listeyi alır.
import React from 'react';
import { getBreadcrumb } from '../utils/pageRoutes';

export default function Breadcrumb({ activePage, onNavigate }) {
  const crumbs = getBreadcrumb(activePage);
  // Dashboard'dayken breadcrumb gösterme (tek item olur)
  if (!crumbs || crumbs.length <= 1) return null;

  return (
    <nav style={S.wrap} aria-label="breadcrumb">
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        // isGroup: tıklanmaz (sadece kategori adı), current: bold ama tıklanmaz
        const clickable = !c.isGroup && !isLast && onNavigate;
        return (
          <React.Fragment key={c.key || i}>
            {i > 0 && <span style={S.sep} aria-hidden="true">›</span>}
            {clickable ? (
              <button type="button" onClick={() => onNavigate(c.key)} style={S.link}>
                {c.label}
              </button>
            ) : (
              <span style={c.current ? S.current : S.dim}>{c.label}</span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

const S = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '8px 16px',
    fontSize: 'var(--text-xs)',
    color: 'var(--text-tertiary)',
    borderBottom: '1px solid var(--border-secondary)',
    background: 'var(--bg-secondary)',
    flexWrap: 'wrap',
  },
  link: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'var(--text-xs)',
    color: 'var(--text-secondary)',
    fontWeight: 500,
    padding: '2px 4px',
    borderRadius: 'var(--r-xs)',
    transition: 'background 0.1s, color 0.1s',
    fontFamily: 'inherit',
  },
  sep: {
    color: 'var(--text-tertiary)',
    fontSize: 'var(--text-sm)',
    margin: '0 2px',
  },
  current: {
    color: 'var(--text-primary)',
    fontWeight: 600,
  },
  dim: {
    color: 'var(--text-tertiary)',
  },
};
